(function () {
  function normalize(value) {
    return (value || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  function detectOptionIndex(names, keywords) {
    return names.findIndex(function (name) {
      var n = normalize(name);
      return keywords.some(function (keyword) { return n.indexOf(keyword) > -1; });
    });
  }

  function setupReveal(scope) {
    var nodes = scope.querySelectorAll("[data-kt-reveal]");
    var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced || !("IntersectionObserver" in window)) {
      nodes.forEach(function (n) { n.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: "0px 0px -8% 0px" });
    nodes.forEach(function (n) { io.observe(n); });
  }

  function setupLightbox(scope) {
    function unlockLightboxScroll() {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      document.documentElement.classList.remove("kt-p10-lightbox-open");
      document.body.classList.remove("kt-p10-lightbox-open");
    }
    function closeLightbox() {
      var lightbox = document.querySelector("[data-kt-p10-lightbox]");
      if (!lightbox) {
        unlockLightboxScroll();
        return;
      }
      var image = lightbox.querySelector("[data-kt-p10-lightbox-image]");
      var caption = lightbox.querySelector("[data-kt-p10-lightbox-caption]");
      lightbox.classList.remove("is-open");
      lightbox.setAttribute("aria-hidden", "true");
      if (image) {
        image.removeAttribute("src");
        image.removeAttribute("alt");
      }
      if (caption) caption.textContent = "";
      unlockLightboxScroll();
    }
    scope.querySelectorAll("[data-kt-p10-lightbox-trigger]").forEach(function (trigger) {
      if (trigger.dataset.ktBound === "true") return;
      trigger.dataset.ktBound = "true";
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        var lightbox = document.querySelector("[data-kt-p10-lightbox]");
        if (!lightbox) {
          unlockLightboxScroll();
          return;
        }
        var image = lightbox.querySelector("[data-kt-p10-lightbox-image]");
        var caption = lightbox.querySelector("[data-kt-p10-lightbox-caption]");
        if (!image) return;
        image.src = trigger.getAttribute("data-kt-p10-lightbox-trigger") || "";
        image.alt = trigger.getAttribute("data-kt-p10-lightbox-alt") || "";
        if (caption) caption.textContent = trigger.getAttribute("data-kt-p10-lightbox-caption") || "";
        lightbox.classList.add("is-open");
        lightbox.setAttribute("aria-hidden", "false");
        document.documentElement.classList.add("kt-p10-lightbox-open");
        document.body.classList.add("kt-p10-lightbox-open");
        document.documentElement.style.overflow = "hidden";
        document.body.style.overflow = "hidden";
      });
    });
    var lightbox = document.querySelector("[data-kt-p10-lightbox]");
    if (!lightbox) return;
    var closeBtn = lightbox.querySelector("[data-kt-p10-lightbox-close]");
    if (closeBtn && !closeBtn.dataset.ktBound) {
      closeBtn.dataset.ktBound = "true";
      closeBtn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeLightbox();
        return;
      });
    }
    if (!lightbox.dataset.ktBound) {
      lightbox.dataset.ktBound = "true";
      lightbox.addEventListener("click", function (event) {
        if (event.target === lightbox) {
          event.preventDefault();
          event.stopPropagation();
          closeLightbox();
        }
      });
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape") closeLightbox();
      });
    }
  }

  function setupGuideModal(scope) {
    if (document.documentElement.dataset.ktP10GuideInit === "true") return;
    document.documentElement.dataset.ktP10GuideInit = "true";

    function unlockGuideScroll() {
      document.documentElement.classList.remove("kt-p10-modal-open");
      document.body.classList.remove("kt-p10-modal-open");
      document.documentElement.classList.remove("modal-open");
      document.body.classList.remove("modal-open");
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    }

    function openGuide(event) {
      if (event) event.preventDefault();
      var modal = document.querySelector("[data-kt-p10-guide-modal]");
      if (!modal || !document.body.contains(modal)) {
        unlockGuideScroll();
        return;
      }
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("kt-p10-modal-open");
      document.body.classList.add("kt-p10-modal-open");
      document.documentElement.classList.add("modal-open");
      document.body.classList.add("modal-open");
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    }
    function closeGuide() {
      var modal = document.querySelector("[data-kt-p10-guide-modal]");
      if (modal) {
        modal.classList.remove("is-open");
        modal.setAttribute("aria-hidden", "true");
      }
      unlockGuideScroll();
    }

    document.addEventListener("click", function (event) {
      var openBtn = event.target.closest("[data-kt-p10-guide-open]");
      if (openBtn) {
        openGuide(event);
        return;
      }

      var closeBtn = event.target.closest("[data-kt-p10-guide-close]");
      if (closeBtn) {
        event.preventDefault();
        closeGuide();
        return;
      }

      var modal = event.target.closest("[data-kt-p10-guide-modal]");
      if (modal && event.target === modal) {
        closeGuide();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeGuide();
      }
    });
  }

  function setupHeroPins(hero) {
    var buttons = Array.prototype.slice.call(hero.querySelectorAll("[data-kt-p10-pin]"));
    var title = hero.querySelector("[data-kt-p10-active-title]");
    var value = hero.querySelector("[data-kt-p10-active-value]");
    var body = hero.querySelector("[data-kt-p10-active-body]");
    var close = hero.querySelector("[data-kt-p10-active-close]");
    var panel = hero.querySelector(".kt-p10-active-pin");
    if (!buttons.length || !title || !body) return;
    function activate(button) {
      buttons.forEach(function (btn) {
        btn.classList.toggle("is-active", btn === button);
        btn.setAttribute("aria-pressed", btn === button ? "true" : "false");
      });
      if (panel) panel.hidden = false;
      title.textContent = button.getAttribute("data-kt-p10-title") || "";
      if (value) value.textContent = button.getAttribute("data-kt-p10-value") || "";
      body.textContent = button.getAttribute("data-kt-p10-body") || "";
    }
    buttons.forEach(function (button, index) {
      if (button.dataset.ktBound === "true") return;
      button.dataset.ktBound = "true";
      button.addEventListener("click", function () { activate(button); });
      if (index === 0) activate(button);
    });
    if (close && !close.dataset.ktBound) {
      close.dataset.ktBound = "true";
      close.addEventListener("click", function () {
        if (panel) panel.hidden = true;
      });
    }
  }

  function setupAnatomy(section) {
    var buttons = Array.prototype.slice.call(section.querySelectorAll("[data-kt-p10-hotspot]"));
    var tags = Array.prototype.slice.call(section.querySelectorAll("[data-kt-p10-hotspot-tag]"));
    var title = section.querySelector("[data-kt-p10-hotspot-title]");
    var body = section.querySelector("[data-kt-p10-hotspot-body]");
    var iconNode = section.querySelector("[data-kt-p10-hotspot-icon]");
    if (!buttons.length || !title || !body) return;
    function activate(button) {
      buttons.forEach(function (btn) {
        btn.classList.toggle("is-active", btn === button);
        btn.setAttribute("aria-pressed", btn === button ? "true" : "false");
      });
      tags.forEach(function (tag) {
        tag.classList.toggle("is-active", tag.getAttribute("data-kt-p10-hotspot-tag") === button.getAttribute("data-kt-p10-hotspot"));
      });
      title.textContent = button.getAttribute("data-kt-p10-title") || "";
      body.textContent = button.getAttribute("data-kt-p10-body") || "";
      if (iconNode) {
        var source = button.querySelector(".kt-p10-picto-core");
        iconNode.innerHTML = source ? source.innerHTML : "";
      }
    }
    buttons.forEach(function (button, index) {
      if (button.dataset.ktBound === "true") return;
      button.dataset.ktBound = "true";
      button.addEventListener("click", function () { activate(button); });
      if (index === 0) activate(button);
    });
    tags.forEach(function (tag) {
      if (tag.dataset.ktBound === "true") return;
      tag.dataset.ktBound = "true";
      tag.addEventListener("click", function () {
        var key = tag.getAttribute("data-kt-p10-hotspot-tag");
        var target = buttons.find(function (button) { return button.getAttribute("data-kt-p10-hotspot") === key; });
        if (target) activate(target);
      });
    });
  }

  function setupGalleryToggle(scope) {
    scope.querySelectorAll("[data-kt-p10-gallery-section]").forEach(function (section) {
      var toggle = section.querySelector("[data-kt-p10-gallery-toggle]");
      if (!toggle || toggle.dataset.ktBound === "true") return;
      toggle.dataset.ktBound = "true";
      var items = Array.prototype.slice.call(section.querySelectorAll("[data-kt-p10-gallery-item]"));
      var initialVisible = parseInt(section.getAttribute("data-kt-p10-gallery-initial") || "6", 10) || 6;
      var expanded = false;
      function render() {
        items.forEach(function (item, index) {
          if (expanded || index < initialVisible) {
            item.hidden = false;
          } else {
            item.hidden = true;
          }
        });
        var label = expanded
          ? (toggle.getAttribute("data-less-label") || "Voir moins")
          : (toggle.getAttribute("data-more-label") || "Voir plus");
        var textNode = toggle.querySelector("span");
        if (textNode) textNode.textContent = label;
        toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
      }
      toggle.addEventListener("click", function () {
        expanded = !expanded;
        render();
      });
      render();
    });
  }

  function setupHeroProduct(hero) {
    if (!hero || hero.dataset.ktProductInit === "true") return;
    hero.dataset.ktProductInit = "true";

    var productData = hero.querySelector("[data-kt-p10-product-json]");
    if (!productData) return;
    var data = JSON.parse(productData.textContent || "{}");
    var variants = data.variants || [];
    var optionNames = data.optionNames || [];
    var form = hero.querySelector("[data-kt-p10-form]");
    var variantInput = hero.querySelector("[data-kt-p10-variant-id]");
    var quantityInput = hero.querySelector("[data-kt-p10-qty-input]");
    var qtyMinus = hero.querySelector("[data-kt-p10-qty-minus]");
    var qtyPlus = hero.querySelector("[data-kt-p10-qty-plus]");
    var priceNodes = document.querySelectorAll("[data-kt-p10-price]");
    var compareNodes = document.querySelectorAll("[data-kt-p10-compare-price]");
    var statusNodes = document.querySelectorAll("[data-kt-p10-status]");
    var ctaLabelNodes = document.querySelectorAll("[data-kt-p10-cta-label]");
    var formButtons = document.querySelectorAll("[data-kt-p10-submit]");
    var colorNote = hero.querySelector("[data-kt-p10-color-note]");
    var sticky = hero.querySelector("[data-kt-p10-sticky]");
    var stickyTrigger = hero.querySelector("[data-kt-p10-sticky-trigger]");
    var lang = document.documentElement.lang && document.documentElement.lang.indexOf("en") > -1 ? "en" : "fr";
    var labels = {
      stateAvailable: hero.dataset.ktP10StateAvailable || "",
      stateUnavailable: hero.dataset.ktP10StateUnavailable || "",
      ctaCore: hero.dataset.ktP10CtaCore || "",
      ctaElite: hero.dataset.ktP10CtaElite || ""
    };

    var finishIndex = detectOptionIndex(optionNames, ["version", "variante", "variant", "modele", "model", "type", "finition", "finish"]);
    var colorIndex = detectOptionIndex(optionNames, ["couleur", "coloris", "color", "colour"]);
    var sizeIndex = detectOptionIndex(optionNames, ["taille", "size"]);
    var formatter = new Intl.NumberFormat(lang === "en" ? "en-US" : "fr-FR", { style: "currency", currency: data.currency || "EUR" });
    var hasVariantInUrl = new URLSearchParams(window.location.search).has("variant");

    function isElite(variant) {
      return variant && variant.options && variant.options.some(function (value) {
        var n = normalize(value);
        return n.indexOf("elite") > -1 || n.indexOf("electronique") > -1 || n.indexOf("electronic") > -1 || n.indexOf("avec capteur") > -1;
      });
    }
    function isCore(variant) {
      return variant && variant.options && variant.options.some(function (value) {
        var n = normalize(value);
        return n.indexOf("core") > -1 || n.indexOf("standard") > -1 || n.indexOf("sans capteur") > -1;
      });
    }
    function isWhite(value) {
      var n = normalize(value);
      return n.indexOf("white") > -1 || n.indexOf("blanc") > -1;
    }
    function isMedium(value) {
      return normalize(value) === "m";
    }
    function money(cents) {
      return formatter.format((cents || 0) / 100);
    }
    function getVariantById(id) {
      return variants.find(function (variant) { return String(variant.id) === String(id); }) || null;
    }
    function pickDefault() {
      if (hasVariantInUrl) {
        var id = new URLSearchParams(window.location.search).get("variant");
        var requested = getVariantById(id);
        if (requested) return requested;
      }
      var eliteVariants = variants.filter(isElite);
      var exact = eliteVariants.find(function (variant) {
        return variant.available && colorIndex > -1 && sizeIndex > -1 && isWhite(variant.options[colorIndex]) && isMedium(variant.options[sizeIndex]);
      });
      if (exact) return exact;
      var eliteWhite = eliteVariants.find(function (variant) {
        return variant.available && colorIndex > -1 && isWhite(variant.options[colorIndex]);
      });
      if (eliteWhite) return eliteWhite;
      return eliteVariants.find(function (variant) { return variant.available; }) || variants.find(function (variant) { return variant.available; }) || variants[0] || null;
    }

    var currentVariant = pickDefault();
    var currentSelection = currentVariant ? currentVariant.options.slice() : optionNames.map(function () { return ""; });

    function buttonGroups() {
      return Array.prototype.slice.call(hero.querySelectorAll("[data-kt-p10-option-group]"));
    }

    function isLockedColor(value) {
      if (colorIndex === -1 || finishIndex === -1) return false;
      var finish = currentSelection[finishIndex] || "";
      if (normalize(finish).indexOf("elite") === -1 && normalize(finish).indexOf("electronique") === -1 && normalize(finish).indexOf("electronic") === -1 && normalize(finish).indexOf("avec capteur") === -1) return false;
      return !variants.some(function (variant) { return isElite(variant) && normalize(variant.options[colorIndex]) === normalize(value); });
    }

    function chooseVariant(position, value) {
      var desired = currentSelection.slice();
      desired[position] = value;
      var exact = variants.find(function (variant) {
        return variant.options.every(function (opt, idx) { return normalize(opt) === normalize(desired[idx]); });
      });
      if (exact) return exact;
      var candidates = variants.filter(function (variant) { return normalize(variant.options[position]) === normalize(value); });
      candidates.sort(function (a, b) {
        function score(variant) {
          var total = variant.available ? 100 : 0;
          variant.options.forEach(function (opt, idx) {
            if (normalize(opt) === normalize(desired[idx])) total += 8;
          });
          if (isElite(variant)) total += 10;
          if (colorIndex > -1 && isWhite(variant.options[colorIndex])) total += 8;
          if (sizeIndex > -1 && isMedium(variant.options[sizeIndex])) total += 6;
          return total;
        }
        return score(b) - score(a);
      });
      return candidates[0] || currentVariant;
    }

    function renderOptions() {
      buttonGroups().forEach(function (group) {
        var position = Number(group.getAttribute("data-kt-p10-option-group")) - 1;
        group.querySelectorAll("[data-kt-p10-option-btn]").forEach(function (button) {
          var value = button.getAttribute("data-kt-p10-option-btn") || "";
          var nextSelection = currentSelection.slice();
          nextSelection[position] = value;
          var matching = variants.find(function (variant) {
            return variant.options.every(function (optionValue, optionIndex) {
              if (optionIndex === position) return normalize(optionValue) === normalize(value);
              return !nextSelection[optionIndex] || normalize(optionValue) === normalize(nextSelection[optionIndex]);
            });
          });
          var active = normalize(currentSelection[position]) === normalize(value);
          var locked = position === colorIndex && isLockedColor(value);
          button.classList.toggle("is-active", active);
          button.classList.toggle("is-disabled", !matching);
          button.classList.toggle("is-locked", locked);
          button.disabled = !matching || locked;
          button.setAttribute("aria-pressed", active ? "true" : "false");
        });
      });
    }

    function syncVariant() {
      if (!currentVariant) return;
      currentSelection = currentVariant.options.slice();
      if (variantInput) variantInput.value = currentVariant.id;
      priceNodes.forEach(function (node) { node.textContent = money(currentVariant.price); });
      compareNodes.forEach(function (node) {
        if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
          node.textContent = money(currentVariant.compare_at_price);
          node.hidden = false;
        } else {
          node.hidden = true;
        }
      });
      var label = isCore(currentVariant)
        ? labels.ctaCore
        : labels.ctaElite;
      ctaLabelNodes.forEach(function (node) { node.textContent = label; });
      statusNodes.forEach(function (node) {
        var txt = currentVariant.available
          ? labels.stateAvailable
          : labels.stateUnavailable;
        node.textContent = txt;
        node.classList.toggle("is-available", !!currentVariant.available);
        node.classList.toggle("is-unavailable", !currentVariant.available);
      });
      if (colorNote) {
        colorNote.hidden = !isElite(currentVariant);
      }
      formButtons.forEach(function (button) { button.disabled = !currentVariant.available; });
      var url = new URL(window.location.href);
      url.searchParams.set("variant", currentVariant.id);
      window.history.replaceState({}, "", url.toString());
      renderOptions();
    }

    buttonGroups().forEach(function (group) {
      group.querySelectorAll("[data-kt-p10-option-btn]").forEach(function (button) {
        if (button.dataset.ktBound === "true") return;
        button.dataset.ktBound = "true";
        button.addEventListener("click", function () {
          if (button.disabled) return;
          var position = Number(group.getAttribute("data-kt-p10-option-group")) - 1;
          currentVariant = chooseVariant(position, button.getAttribute("data-kt-p10-option-btn") || "");
          syncVariant();
        });
      });
    });

    function syncQty() {
      if (!quantityInput) return;
      var parsed = parseInt(quantityInput.value, 10);
      quantityInput.value = String(Number.isFinite(parsed) && parsed > 0 ? parsed : 1);
    }
    if (qtyMinus) qtyMinus.addEventListener("click", function () { syncQty(); quantityInput.value = String(Math.max(1, parseInt(quantityInput.value, 10) - 1)); });
    if (qtyPlus) qtyPlus.addEventListener("click", function () { syncQty(); quantityInput.value = String(Math.max(1, parseInt(quantityInput.value, 10) + 1)); });
    if (quantityInput) {
      quantityInput.addEventListener("input", syncQty);
      quantityInput.addEventListener("blur", syncQty);
    }
    if (form) {
      form.addEventListener("submit", function () {
        syncQty();
        if (variantInput && currentVariant) variantInput.value = currentVariant.id;
      });
    }
    if (sticky && stickyTrigger && !sticky.dataset.ktBound) {
      sticky.dataset.ktBound = "true";
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle("is-visible", !entry.isIntersecting);
        });
      }, { threshold: .1 });
      observer.observe(stickyTrigger);
    }

    syncVariant();
  }

  function setupPreorderVip(scope) {
    scope.querySelectorAll("[data-preorder-vip]").forEach(function (root) {
      if (root.dataset.ktBound === "true") return;
      root.dataset.ktBound = "true";

      var deadlineValue = root.getAttribute("data-preorder-deadline") || "";
      var countdown = root.querySelector("[data-preorder-countdown]");
      var ended = root.querySelector("[data-preorder-ended]");
      var daysEl = root.querySelector("[data-preorder-days]");
      var hoursEl = root.querySelector("[data-preorder-hours]");
      var minutesEl = root.querySelector("[data-preorder-minutes]");
      var secondsEl = root.querySelector("[data-preorder-seconds]");
      var timerId = null;

      function pad(value) {
        return String(Math.max(0, value)).padStart(2, "0");
      }

      function setEndedState() {
        if (countdown) countdown.hidden = true;
        if (ended) ended.hidden = false;
        root.classList.add("is-ended");
      }

      function setActiveState() {
        if (countdown) countdown.hidden = false;
        if (ended) ended.hidden = true;
        root.classList.remove("is-ended");
      }

      function render(diff) {
        var totalSeconds = Math.max(0, Math.floor(diff / 1000));
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;
        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }

      if (!deadlineValue) {
        setEndedState();
        render(0);
        return;
      }

      var deadline = new Date(deadlineValue);
      if (isNaN(deadline.getTime())) {
        setEndedState();
        render(0);
        return;
      }

      function tick() {
        var diff = deadline.getTime() - Date.now();
        if (diff <= 0) {
          if (timerId) {
            window.clearInterval(timerId);
            timerId = null;
          }
          render(0);
          setEndedState();
          return;
        }
        setActiveState();
        render(diff);
      }

      tick();
      timerId = window.setInterval(tick, 1000);
    });
  }

  function init(scope) {
    setupReveal(scope);
    setupLightbox(scope);
    setupGuideModal(scope);
    setupPreorderVip(scope);
    setupGalleryToggle(scope);
    scope.querySelectorAll(".kt-p10-hero[data-kt-p10-product-root]").forEach(setupHeroProduct);
    scope.querySelectorAll(".kt-p10-hero").forEach(setupHeroPins);
    scope.querySelectorAll(".kt-p10-anatomy").forEach(setupAnatomy);
  }

  document.addEventListener("DOMContentLoaded", function () { init(document); });
  document.addEventListener("shopify:section:load", function (event) { init(event.target); });
})();
